export var DATE_FORMAT = "MMMM D, YYYY";
export var DATE_FORMAT_CONSTRAINED = "MMM D, YYYY";
export var SHORT_DATE_FORMAT = "YYYY-MM-DD";
export var TIME_FORMAT = "h:mm A z";
export var SHORT_TIME_FORMAT = "HH:mm:ss";
export var INPUT_TIME_FORMAT = "hh:mm A";
